const appGlobalState = (state = { isMapActive: false }, action) => {
  switch (action.type) {
    case 'TOGGLE_MAP_STATE':
      return {
        ...state,
        isMapActive: !state.isMapActive
      };
    default:
      return state;
  }
};

export default appGlobalState;

export const getMapState = state => state.isMapActive;


// WEBPACK FOOTER //
// ./app/src/state/reducers/appGlobalState.js